import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { BOOKING_URL } from '../../config/links';
import './CTA.css';

const CTA = () => {
  const { t } = useTranslation();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  return (
    <section className="cta" ref={ref}>
      <div className="cta-background">
        <img
          src="/assets/images/digital-globe.jpg"
          alt="Technology Background"
          className="background-image"
        />
        <div className="overlay"></div>
      </div>

      <div className="container">
        <motion.div
          className="cta-content"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <img src="/assets/images/Startup-Light Streamline Core-Neon.svg" alt={t('cta.title')} className="cta-icon" loading="lazy" decoding="async" />
          <h2>{t('cta.title')}</h2>
          <p>{t('cta.subtitle')}</p>
          <motion.a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="cta-button"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            {t('cta.button')}
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;